import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import coverImage from '../assets/images/cover2.jpg'
import coverImagePlaceholder from '../assets/images/cover2-min.jpg'
import './HalfCover.sass'
import SNSButtons from "./SNSButtons";
import {useMediaQuery, useTheme} from "@mui/material";

function HalfCover() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <div className={'half_cover'}>
            <div className={isMobile ? 'half_cover__full' : 'half_cover__left'}>
                <LazyLoadImage
                    alt={'background of ocean view taken at a hotel in puerto rico'}
                    src={coverImage}
                    placeholderSrc={coverImagePlaceholder}
                    className={isMobile ? 'half_cover__full__img' : 'half_cover__left__img'}
                />
            </div>

            <div className={isMobile ? 'half_cover__full_text' : "half_cover__right"}>
                <div className={isMobile ? 'half_cover__text_mobile' : 'half_cover__text'}>
                    <h1 className={isMobile ? 'half_cover__text__name_mobile' : 'half_cover__text__name'}>More About Me</h1>
                    <SNSButtons spacing={isMobile ? '1rem' : '2rem'} />
                </div>
            </div>

        </div>
    );
}

export default HalfCover;